export const initialErrorValue = {
  period: false,
  noRange: false,
  required: false,
};
